import React, { useState } from "react";
import { TextField, Button, Checkbox, Grid, Card, Typography, Box, FormControl, IconButton, Input, List, ListItem } from "@mui/material";
import { attachments, ServiceAttachments, ServiceColumn } from "../../types/assetTypes";
import { CustomMessage } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import { setLoading } from "../../store/CommonSlice";
import { saveInspectionData, updateInspectionData, updateServiceData, uploadFiles } from "../../api/Services/assetServices";
import { useDispatch, useSelector } from "react-redux";
import { FILE_DOWNLOAD_PREVIEW } from "../../api/endpoint";
import ImagePreview from "../../Component/ImagePreview";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { RootState } from "../../store/Reduxstore";




interface ServiceEditingFormProps {
  setEditOpen: (open: boolean) => void;
  serviceTemplateData: {
    templateColumnId: number;
    templateColumnName: string;
    isChecked: boolean;
    commands?: string | null;
    attachments: attachments;
    serviceAttachments: ServiceAttachments[];
  }[];
  selectedRowData:{
    serviceReportingId: number;
    assetName: string;
    service: string;
    user_id: number;
    name: string;
    familyAssetId: number;
    familyName: string;
    serviceTemplateId: number;
    serviceTemplateName: string;
    currentLocationId: number;
    countryName: string;
    regionId: number;
    regionName: string;
    projectId: number;
    projectName: string;
    date: Date;  // ✅ Make `date` optional
    commonComments: string;
    serviceName: string;
    engineHours: string;
} | null; // ✅ Allow null
}

const ServiceEditingForm: React.FC<ServiceEditingFormProps> = ({
  setEditOpen,
  selectedRowData,   
  serviceTemplateData,
  }) => {
    console.log("Selected Row Data:", selectedRowData); 
    // ✅ Store editable data in state
    const [editableData, setEditableData] = useState<ServiceColumn[]>(serviceTemplateData);
    console.log(editableData, "Edit");
     const [templateData, setTemplateData] = useState<{ 
        templateColumnId: number;
        templateColumnName: string; 
        attachments: attachments;
        serviceAttachments: ServiceAttachments[];
        
        checked: boolean; 
        text: string 
      }[]>([]);
  
    // ✅ Handle checkbox toggle
    const handleCheckboxChange = (id: number) => {
      setEditableData((prev) =>
        prev.map((item) =>
          item.templateColumnId === id ? { ...item, isChecked: !item.isChecked } : item
        )
      );
    };

    const userDetails = useSelector((state: RootState) => state.auth);

      const removeFile = (templateColumnId: number, serviceAttachmentId: number) => {
      setEditableData(prevData =>
        prevData.map(item => {
          if (item.templateColumnId === templateColumnId) {
            
            const attachmentsArray = Array.isArray(item.serviceAttachments)
              ? item.serviceAttachments
              : item.serviceAttachments
              ? [item.serviceAttachments]
              : [];

            // Filter out the file to remove
            const updatedAttachments = attachmentsArray.filter(
              file => file.serviceAttachmentId !== serviceAttachmentId
            );

            // If updatedAttachments is empty, you might want to set to null or empty array based on your logic
            return {
              ...item,
              serviceAttachments: updatedAttachments,
            };
          }
          return item;
        })
      );
    };

    // ✅ Handle text field change
    const handleTextChange = (id: number, value: string) => {
      setEditableData((prev) =>
        prev.map((item) =>
          item.templateColumnId === id ? { ...item, commands: value } : item
        )
      );
    };
    const dispatch = useDispatch(); // ✅ Move inside the component
  
    // ✅ Handle Save Button
    const handleSave = async () => {
        if (!selectedRowData) {
          console.error("No selected row data available.");
          CustomMessage("No data selected for editing", "error", enqueueSnackbar);
          return;
        }
      
        const payload = {
          serviceReportingId: selectedRowData.serviceReportingId ?? 0, 
          user_id: selectedRowData.user_id, 
          name: selectedRowData.name,  
          date: selectedRowData.date,
          service: selectedRowData.service, 
          familyAssetId: selectedRowData.familyAssetId ?? 0, 
          familyName: selectedRowData.familyName ?? "", 
          assetName: selectedRowData.assetName ?? "", 
          serviceTemplateId: selectedRowData.serviceTemplateId ?? 0, 
          serviceTemplateName: selectedRowData.serviceTemplateName ?? "", 
          currentLocationId: selectedRowData.currentLocationId ?? 0,
          countryName: selectedRowData.countryName ?? "",

          regionId: selectedRowData.regionId ?? 0,
          regionName: selectedRowData.regionName ?? "",

          projectId: selectedRowData.projectId ?? 0,
          projectName: selectedRowData.projectName ?? "",
          commonComments: selectedRowData.commonComments ?? "",
          engineHours: selectedRowData.engineHours ?? "",
          serviceName: selectedRowData.serviceName ?? "",
         
      
          details: editableData.map(item => ({
            templateColumnId: item.templateColumnId ?? 0,  
            isChecked: item.isChecked === true,  // ✅ Ensures `true` if checked, `false` if unchecked
            commands: item.commands || "", 
           serviceAttachments: Array.isArray(item.serviceAttachments) 
            ? item.serviceAttachments.map(att => ({
                serviceAttachmentId: att.attachmentId,
                attachmentId: att.attachmentId,
                name: att.name,
                savedAttachmentName: att.savedAttachmentName,
              })) 
            : [],

         
          })),
        };
      
        console.log("Saving Data:", payload);
      
        try {
          const response = await updateServiceData(payload);
          console.log("Response:", response);
      
          if (response?.status?.code === 201 || response?.status?.code === 200) {
            CustomMessage(response.status.message, "success", enqueueSnackbar);
            setEditOpen(false);
          } else {
            CustomMessage(response.status.message, "error", enqueueSnackbar);
          }
        } catch (error: any) {
          console.error("Error saving service report:", error);
          CustomMessage(error?.message || "Failed to save", "error", enqueueSnackbar);
        } finally {
          dispatch(setLoading(false));
        }
      };

    const allowedImageTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];

      const handleFileUpload = async (
        event: React.ChangeEvent<HTMLInputElement>,
        templateColumnId: number
      ) => {
        if (!event.target.files || event.target.files.length === 0) {
          CustomMessage("No file selected", "error", enqueueSnackbar);
          return;
        }

        const fileArray = Array.from(event.target.files);

        // Validate image types
        const invalidFile = fileArray.find(file => !allowedImageTypes.includes(file.type));
        if (invalidFile) {
          CustomMessage(
            `Only image files (JPEG, PNG, JPG, WEBP) are allowed. "${invalidFile.name}" is not valid.`,
            "error",
            enqueueSnackbar
          );
          return;
        }

        dispatch(setLoading(true));

        try {
          const uploadPromises = fileArray.map(async (file) => {
            const formData = new FormData();
            formData.append("file", file);

            const response = await uploadFiles(formData);

            if (response.status.code === 201) {
              const uploaded = response.data;

              // Adjust IDs if needed depending on your API response
              const newAttachment: ServiceAttachments = {
                attachmentId: uploaded.attachmentId,
                serviceAttachmentId: uploaded.attachmentId,
                name: uploaded.name,
                savedAttachmentName: uploaded.savedAttachmentName,
              };

              return newAttachment;
            } else {
              throw new Error(`Upload failed with status: ${response.status.code}`);
            }
          });

          const uploadedFiles = await Promise.all(uploadPromises);

          setEditableData(prev =>
            prev.map(item =>
              item.templateColumnId === templateColumnId
                ? {
                    ...item,
                    serviceAttachments: [...(Array.isArray(item.serviceAttachments) ? item.serviceAttachments : []), ...uploadedFiles],
                  }
                : item
            )
          );

          CustomMessage("Image(s) uploaded successfully", "success", enqueueSnackbar);
        } catch (error: any) {
          console.error("Upload error", error);
          CustomMessage(`File upload error: ${error.message}`, "error", enqueueSnackbar);
        } finally {
          dispatch(setLoading(false));
          // Clear file input to allow re-upload of same files if needed
          event.target.value = "";
        }
      };

    
  const handleCancel = () => {
      
      setEditOpen(false); // Close the form after saving
    };

    const styles: { [key: string]: React.CSSProperties } = {
      heading: {
        textAlign: "left",
        color: "#333",
        marginBottom: "10px",
        fontSize: "18px",
        fontWeight: "bold",
      },
    }  

    return (
    
      <div>
        <Typography variant="h6" style={styles.heading} align="left" gutterBottom>Edit Service Data</Typography>
        <Card
          style={{
            marginTop: "0",
            padding: "20px",
            maxWidth: "100%", // ⬆️ Increased width for a better layout
            marginLeft: "auto",
            marginRight: "auto",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Softer shadow
            borderRadius: "4px",
            backgroundColor: "#f9f9f9", // Softer background color
          }}
        >
          
      
          {/* 🔹 Non-Editable Details Section */}
          {selectedRowData && (
            <Grid
              container
              spacing={2}
              style={{
                marginBottom: "20px",
                padding: "20px",
                background: "#fff",
                borderRadius: "10px",
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "5px",
              }}
            >
              
            <Grid container spacing={2} style={{ marginTop: '16px' }}>
              {/* Row 1 */}
              <Grid item xs={4}>
                <Typography variant="body1" noWrap>
                  <strong>Family Name:</strong> {selectedRowData.familyName}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1" noWrap>
                  <strong>Asset Name:</strong> {selectedRowData.assetName}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1" noWrap>
                  <strong>Name:</strong> {selectedRowData.name}
                </Typography>
              </Grid>

              {/* Row 2 */}
              <Grid item xs={4}>
                <Typography variant="body1" noWrap>
                  <strong>Country:</strong> {selectedRowData.countryName}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1" noWrap>
                  <strong>Region:</strong> {selectedRowData.regionName}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1" noWrap>
                  <strong>Project:</strong> {selectedRowData.projectName}
                </Typography>
              </Grid>

              {/* Row 3 */}
              <Grid item xs={4}>
                <Typography variant="body1" noWrap>
                  <strong>Service:</strong> {selectedRowData.serviceName}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1" noWrap>
                  <strong>Engine Hours:</strong> {selectedRowData.engineHours}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1" noWrap>
                  <strong>Date:</strong>{" "}
                  {selectedRowData.date
                    ? new Date(selectedRowData.date).toLocaleDateString()
                    : "N/A"}
                </Typography>
              </Grid>

              {/* Comments - full width */}
              <Grid item xs={12}>
                <Typography variant="body1">
                  <strong>Comments:</strong> {selectedRowData.commonComments}
                </Typography>
              </Grid>
            </Grid>


           

            </Grid>
          )}
      
          {/* 🔹 Editable Section with Provided Styling */}
          <Card
            style={{
              marginTop: "20px",
              padding: "15px",
              maxWidth: "100%",
              marginLeft: "",
              marginRight: "",
            }}
          >
            <Grid container spacing={1}>
              {editableData.map((item) => (
                <Grid
                  item
                  xs={12}
                  key={item.templateColumnId}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                  }}
                >
                  {/* Image Circle */}
                        <div
                          style={{
                            width: "59px",
                            height: "59px",
                            borderRadius: "50%",
                            border: "1px solid #ccc",
                            overflow: "hidden",
                            backgroundColor: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          {item.attachments && item.attachments.attachmentId && (
                              <ImagePreview
                              alt={`Attachment ${item.attachments.attachmentId}`}
                              src={`${FILE_DOWNLOAD_PREVIEW}${item.attachments.attachmentId}`}
                               
                                style={{
                                  objectFit: "cover",
                                  borderRadius: "50%",                                 
                                  width:"59",
                                  height:"59"
                                  
                                }}
                              />
                            )}
                        </div>
                  
                  <Typography style={{ width: "300px" }}>{item.templateColumnName}</Typography>
      
                  <Checkbox checked={item.isChecked} onChange={() => handleCheckboxChange(item.templateColumnId)} />
      
                  <TextField
                    key={item.templateColumnId}
                    value={item.commands || ""}
                    onChange={(e) => handleTextChange(item.templateColumnId, e.target.value)}
                    placeholder="Commands"
                    variant="outlined"
                    size="small"
                    style={{ width: "300px" }}
                  />
                  <Grid item>
                    <FormControl>
                      <input
                        id={`fileUpload-${item.templateColumnId}`}
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={(e) => handleFileUpload(e, item.templateColumnId)}
                        style={{ fontSize: "14px", width: "200px" }}
                      />
                    </FormControl>

                  </Grid>

                      {(() => {
                      const serviceAttachments = Array.isArray(item.serviceAttachments)
                        ? item.serviceAttachments
                        : item.serviceAttachments
                        ? [item.serviceAttachments]
                        : [];

                      return (
                        serviceAttachments.length > 0 && (
                          <List
                            dense
                            sx={{
                              bgcolor: "background.paper",
                              maxHeight: 200,
                              overflowY: "auto",
                              width: "auto",
                              p: 1,
                              border: "1px solid #eee",
                              borderRadius: 2,
                              flexShrink: 0,
                            }}
                          >
                            {serviceAttachments.map((file) => {
                              const fileUrl = `${FILE_DOWNLOAD_PREVIEW}${file.serviceAttachmentId}`;

                              return (
                                <ListItem
                                  key={file.serviceAttachmentId}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    p: 0.5,
                                  }}
                                >
                                  {/* Image Preview */}
                                  <Box sx={{ width: 59, height: 59, flexShrink: 0 }}>
                                    <ImagePreview
                                      src={fileUrl}
                                      alt={file?.name || "Image Preview"}
                                      style={{
                                        width: "59px",
                                        height: "59px",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </Box>

                                  {/* File Name + Download/Delete */}
                                  <Box display="flex" flexDirection="column" gap={0.5}>
                                    <Typography variant="body2" noWrap sx={{ maxWidth: 120 }}>
                                      {file.name || file.savedAttachmentName}
                                    </Typography>

                                    <Box display="flex" gap={1}>
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          const link = document.createElement("a");
                                          link.href = fileUrl;
                                          link.setAttribute("download", file.name || "image");
                                          document.body.appendChild(link);
                                          link.click();
                                          document.body.removeChild(link);
                                        }}
                                      >
                                        <DownloadIcon fontSize="small" color="primary" />
                                      </IconButton>

                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          removeFile(item.templateColumnId, file.serviceAttachmentId)
                                        }
                                      >
                                        <CloseIcon fontSize="small" color="error" />
                                      </IconButton>
                                    </Box>
                                  </Box>
                                </ListItem>
                              );
                            })}
                          </List>
                        )
                      );
                    })()}

                </Grid>
              ))}
            </Grid>
          </Card>
      
          {/* 🔹 Save Button */}
          {/* 🔹 Save Button */}
            <Grid container justifyContent="end" style={{ marginTop: "30px", display: "flex", gap: "10px" }}>
            <Grid item style={{ display: "flex", gap: "10px" }}> {/* ✅ Add gap here */}
                <Button className="btn btn-secondary text-white" variant="outlined" color="secondary" onClick={handleCancel} style={styless.button}>
                Cancel
                </Button>
                {userDetails.role.some(
                    r => r.roleName === "Admin" || r.roleName === "New Service Write"
                  ) && (
                    <Button
                      className="btn btn-primary"
                      variant="contained"
                      color="primary"
                      onClick={handleSave}
                      style={styless.button}
                    >
                      Submit
                    </Button>
                  )}

            </Grid>
            </Grid>

        </Card>
      </div>
        
      );
  }
  const styless = {
    label: {
      fontSize: '16px',
      fontWeight: 'bold',
      marginBottom: '5px',
    },
    input: {
      background: '#fff',
      borderRadius: '5px',
      height: '40px',
    },
    button: {
      minWidth: '120px',
      height: '40px',
      padding: '10px 0',
    }
  };
  
    export default ServiceEditingForm;
